import { keyframes } from '@emotion/react';
export function panelEnter({ offset, slideFrom }) {
    const translateAxis = slideFrom === 'bottom' ? 'translateY' : 'translateX';
    const direction = slideFrom === 'left' ? -1 : 1;
    return keyframes({
        from: {
            transform: `${translateAxis}(calc(${direction} * ${offset}))`,
        },
        to: {
            transform: `${translateAxis}(0)`,
        },
    });
}
export function panelExit({ offset, slideFrom }) {
    const translateAxis = slideFrom === 'bottom' ? 'translateY' : 'translateX';
    const direction = slideFrom === 'left' ? -1 : 1;
    return keyframes({
        from: {
            transform: `${translateAxis}(0)`,
        },
        to: {
            transform: `${translateAxis}(calc(${direction} * ${offset}))`,
        },
    });
}
